import axios from 'axios';
import VueCookies from 'vue-cookies';

export const getHomeLayoutData = async (locale) => {
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_GPSPOD_ENDPOINT}/gps/home/layouts?locale=${locale}`,
      {
        headers: {
          oktasessionid: VueCookies.get('rocSid'),
        },
      }
    );
    return await response.data;
  } catch (error) {
    console.error('Error fetching home layout data:', error);
    return null;
  }
};

const getLocalStorageKey = (region, notificationType) =>
  `notificationLog_${region}_${notificationType}`;

export const saveUserNotificationLog = (log) => {
  try {
    localStorage.setItem(getLocalStorageKey(log.region, log.notificationType), JSON.stringify(log));
  } catch (error) {
    console.error('Error saving user notification log to localStorage:', error);
  }
};

export const getUserNotificationLog = (region, notificationType) => {
  try {
    const storedLog = localStorage.getItem(getLocalStorageKey(region, notificationType));
    return storedLog ? JSON.parse(storedLog) : null;
  } catch (error) {
    console.error('Error retrieving user notification log from localStorage:', error);
    return null;
  }
};

export const getNotificationToShow = async (region) => {
  const locale = region;
  const homeLayoutData = await getHomeLayoutData(locale);

  if (!homeLayoutData || !homeLayoutData.user || !homeLayoutData.user.serviceSuiteMigrationStatus) {
    return null;
  }

  // Check if user has approved roles for migration notifications
  const approvedRoles = homeLayoutData.user.ApprovedRoles || [];
  const hasApprovedRole = approvedRoles.includes("technical") || 
                        approvedRoles.includes("sleep") || 
                        approvedRoles.includes("ventilator") || 
                        approvedRoles.includes("oxygen");

  if (!hasApprovedRole) {
    return null;
  }

  const migrationStatus = homeLayoutData.user.serviceSuiteMigrationStatus;
  const now = new Date();
  const startDate = new Date(migrationStatus.startDate);
  const endDate = new Date(migrationStatus.endDate);

  const notificationLogType =
    migrationStatus.type === 'PreMigration' ? 'pre-migration' :
    migrationStatus.type === 'DuringMigration' ? 'during-migration' :
    'post-migration-error';

  const log = getUserNotificationLog(region, notificationLogType);

  if (log) {
    return null;
  }

  switch (migrationStatus.type) {
    case 'PreMigration':
      if (now < startDate && now < endDate) {
        return {
          type: 'pre-migration',
          title: 'Service Technician access is moving to Service Suite', // Placeholder title
          message: "Service Technician access is moving to Service Suite: We're moving access to technical service documentation for Product Support from Support Portal to Service Suite. There's nothing you need to do yet. You'll keep your current access to technical service documentation until Service Suite is rolled out in the region." || migrationStatus.message,
          onboardingLink: migrationStatus.onboardingLink,
          contactInfo: migrationStatus.contactInfo,
        };
      }
      break;
    case 'DuringMigration':
      if (now >= startDate && now < endDate) {
        const daysLeft = Math.ceil((endDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
        return {
          type: 'during-migration',
          title: 'Move your access to Service Suite', // Placeholder title
          message: "Move your access to Service Suite: To keep uninterrupted access to technical service documentation, complete your Service Suite onboarding by {migration_end_date}. You can continue using Support Portal until then." || migrationStatus.message, // Use message directly from API
          countdownDays: daysLeft,
          onboardingLink: migrationStatus.onboardingLink,
          contactInfo: migrationStatus.contactInfo,
        };
      }
      break;
    case 'PostMigration':
      if (now >= startDate) {
        return {
          type: 'post-migration-error',
          title: 'Access available through Service Suite', // Placeholder title
          message: "Access available through Service Suite: Your access to technical service documentation is now managed in Service Suite. You don't currently have permission to view this content. Please request onboarding to regain access to technical service documentation." || migrationStatus.message,
          onboardingLink: migrationStatus.onboardingLink,
          contactInfo: migrationStatus.contactInfo,
        };
      }
      break;
    default:
      return null;
  }

  return null;
};
 